import "./PopupTemplateOne.scss";
import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";

function PopupTemplateOne(props) {
    const content = useSelector(
        (state) => state.content.options.template_one_popup
    );

    const showImg = content.image ? true : false;

    let contentClasses = "content-wrapper";
    if (showImg) contentClasses += " img";

    let ctaClasses = "cta-section";
    if (!content.use_cta) ctaClasses += " no-cta";

    function closePopup() {
        props.close();
    }

    function stopClickThrough(e) {
        e.stopPropagation();
    }

    useEffect(() => {
        window.addEventListener("keydown", keyClose);
        return () => {
            window.removeEventListener("keydown", keyClose);
        };
    });

    function keyClose(e) {
        switch (e.keyCode) {
            case 27:
                props.close();
                break;
        }
    }

    return (
        <div className="PopupTemplateOne" onClick={closePopup}>
            <div className="inner-wrapper" onlick={(e) => stopClickThrough(e)}>
                <button className="close-button" onclick={() => closePopup()} />
                <div class={contentClasses}>
                    {showImg && <img class="image" src={content.image.url} />}
                    <div className="content-container">
                        <div className="content-inner-wrapper">
                            <h2
                                className="heading"
                                dangerouslySetInnerHTML={{
                                    __html: content.heading,
                                }}
                            />
                            <img
                                className="deco"
                                src={content.decoration.url}
                            />
                            <p
                                className="copy"
                                dangerouslySetInnerHTML={{
                                    __html: content.copy,
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className={ctaClasses}>
                    <p className="tagline">{content.tagline}</p>
                    {content.use_cta && (
                        <a
                            className="cta-link"
                            href={content.cta_link}
                            target="_blank"
                            id="one-price-all-in-event"
                        >
                            {content.cta_label}
                        </a>
                    )}
                </div>
            </div>
        </div>
    );
}

export default PopupTemplateOne;
